import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>
          Officer South - Ballarto Road Sewer Rising Main and Pump Station
          Upgrade
        </h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We’re installing a new sewer pipeline and upgrading the capacity of
          the Ballarto Road Pump Station, to increase the capacity of the sewer
          network, catering for population growth.
        </p>
        <p>
          This project will install around 15 kilometres of new pipeline which
          will transfer sewerage from the Ballarto Road Sewer Pump Station to
          the Pakenham Wastewater Recycling Plant. The new rising main will help
          to manage sewerage flows within the local area whilst the Pump Station
          upgrade will increase the capacity to manage the additional growth.
        </p>
        <p>
          We’re still in the planning phase for this project and will update our
          webpage when the project is awarded to one of our Industry Partners
          for construction.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/ballartordsrm/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Major Projects (orange)`,
                action: '<a href> link',
                label:
                  'MORE INFO: Officer South - Ballarto Road Sewer Rising Main and Pump Station Upgrade',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800403777">1800 403 777</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Major Projects (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Officer South - Ballarto Road Sewer Rising Main and Pump Station Upgrade',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
